import { Checkbox } from "@/components/ui/checkbox";
import { Link } from "react-router-dom";
import { useToast } from "@/hooks/use-toast";

interface TermsAcceptanceProps {
  acceptedTerms: boolean;
  setAcceptedTerms: (accepted: boolean) => void;
}

export const TermsAcceptance = ({ acceptedTerms, setAcceptedTerms }: TermsAcceptanceProps) => {
  const { toast } = useToast();

  const handleCheckboxChange = (checked: boolean) => {
    console.log('Terms checkbox changed:', checked);
    setAcceptedTerms(checked);
  };

  const handleLinkClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    e.stopPropagation();
    const href = e.currentTarget.getAttribute('href');
    if (href) {
      window.open(href, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <div 
      className="mt-6 relative flex items-start" 
      onClick={(e) => e.stopPropagation()}
    >
      <div className="flex h-5 items-center">
        <Checkbox
          id="terms"
          type="button"
          checked={acceptedTerms}
          onCheckedChange={handleCheckboxChange}
          className="h-4 w-4 rounded border-gray-300 text-everest-teal focus:ring-everest-teal"
          aria-label="Accept terms and conditions"
          onClick={(e) => e.stopPropagation()}
        />
      </div>
      <div className="ml-3 text-sm">
        <label htmlFor="terms" className="font-medium text-gray-700">
          I agree to the{" "}
          <Link 
            to="/terms" 
            className="text-everest-teal hover:text-everest-teal/90 underline"
            onClick={handleLinkClick}
          >
            Terms of Service
          </Link>{" "}
          and{" "}
          <Link 
            to="/privacy" 
            className="text-everest-teal hover:text-everest-teal/90 underline"
            onClick={handleLinkClick}
          >
            Privacy Policy
          </Link>
        </label>
      </div>
    </div>
  );
};